import phoneTypes from '../../enums/phoneTypes';

export default {
  [phoneTypes.business]: 'Teléfono del trabajo',
  [phoneTypes.extension]: 'Teléfono de extensión',
  [phoneTypes.home]: 'Teléfono de casa',
  [phoneTypes.mobile]: 'Teléfono móvil',
  [phoneTypes.phone]: 'Teléfono',
  [phoneTypes.unknown]: 'Tipo de teléfono desconocido',
};
